import { useCallback, useEffect } from 'react';
import { RotasComBarra } from 'enum';
import { useNavigate } from 'react-router-dom';
import {
  Col,
  Container,
  Row,
  ThreeDotsLoader,
} from 'plataforma-fundacao-componentes';
import { getUrlNossoNegocioCoop } from 'services/Api';

export default function NossoNegocioCooperativista() {
  const navigate = useNavigate();

  const handleRedirect = useCallback(async () => {
    const AcceptedUrl = /^(.)+\/registro\/(.+)$/i;
    try {
      const { data } = await getUrlNossoNegocioCoop();

      if (AcceptedUrl.test(data)) {
        const to = data.replace(AcceptedUrl, '/$2');
        navigate(to, { replace: true });
      }
    } catch (err) {
      navigate(RotasComBarra.naoEncontrado);
    }
  }, [navigate]);

  useEffect(() => {
    handleRedirect();
  }, [handleRedirect]);

  return (
    <Container verticalPadding>
      <Row>
        <Col centralized>
          <ThreeDotsLoader />
        </Col>
      </Row>
    </Container>
  );
}
